/**
 * Prefills Shopify checkout from the cart attribute written by Door Builder.
 * Uses the existing Ajax cart: checkout query params on /checkout and on the
 * cart form POST. Does not rebuild line items.
 */
(function () {
  var ATTRIBUTE_ID = 'sm-checkout-delivery-address';

  function parseEmbeddedAddress(text) {
    var value;
    try {
      value = JSON.parse(text);
    } catch (e) {
      return null;
    }
    // Shopify's json filter wraps the cart attribute and writes quotes as
    // \u0026quot;. The first parse turns that into &quot;, which is not JSON.
    if (typeof value === 'string') {
      var decoded = value
        .replace(/&quot;/g, '"')
        .replace(/&#34;/g, '"')
        .replace(/&amp;/g, '&')
        .replace(/&#38;/g, '&');
      try {
        value = JSON.parse(decoded);
      } catch (e) {
        return null;
      }
    }
    return value;
  }

  function readAddress() {
    var el = document.getElementById(ATTRIBUTE_ID);
    if (!el || !el.textContent) return null;
    var raw = parseEmbeddedAddress(el.textContent);
    if (!raw || raw.v !== 1 || typeof raw.address1 !== 'string' || !raw.address1.trim()) {
      return null;
    }
    return raw;
  }

  function prefillSearch(address) {
    var params = new URLSearchParams();
    function set(key, value) {
      params.set('checkout[shipping_address][' + key + ']', value == null ? '' : String(value));
    }
    set('address1', address.address1.trim());
    set('address2', address.address2 || '');
    set('city', address.city || '');
    set('province', address.province || '');
    set('country', address.country || 'AU');
    set('zip', address.zip || '');
    return params.toString();
  }

  function isCheckoutPath(pathname) {
    return /\/checkout$/.test(String(pathname || '').replace(/\/+$/, ''));
  }

  document.addEventListener(
    'click',
    function (event) {
      var address = readAddress();
      if (!address) return;
      var target = event.target;
      if (!target || !target.closest) return;
      var link = target.closest('a[href]');
      if (!link) return;
      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (e) {
        return;
      }
      if (url.origin !== window.location.origin || !isCheckoutPath(url.pathname)) return;
      link.href = url.pathname + '?' + prefillSearch(address);
    },
    true,
  );

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    var submitter = event.submitter;
    if (!submitter || submitter.getAttribute('name') !== 'checkout') return;
    var address = readAddress();
    var action = form.getAttribute('action') || '/cart';
    var url;
    try {
      url = new URL(action, window.location.origin);
    } catch (e) {
      return;
    }
    if (!address) {
      if (url.search) form.setAttribute('action', url.pathname);
      return;
    }
    form.setAttribute('action', url.pathname + '?' + prefillSearch(address));
  });
})();
